import moment from "moment";
// React
import React from "react";
// Bootstrap
import { Well } from "react-bootstrap";
import ShowByLoginType from "common/ui/containers/showByLoginType/ShowByLoginType";
import { superUsers, nonSuperUsers } from "common/ui/containers/showByLoginType/ShowByLoginType";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./DateRangeWarning.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class DateRangeWarning extends React.Component {
    renderForExternalUsers() {
        return (React.createElement("div", { className: styles.container },
            React.createElement(Well, { bsSize: "sm", className: styles.warningWell },
                React.createElement("span", { className: "glyphicon glyphicon-info-sign", "aria-hidden": "true" }),
                React.createElement("h4", null, "Listing View data before Oct 1st 2016 is unavailable and not included in the totals below."),
                React.createElement("h5", null, "We are working on processing this data and will have it available in the near future."))));
    }
    renderForInternalUsers() {
        return (React.createElement("div", { className: styles.container },
            React.createElement(Well, { bsSize: "sm", className: styles.warningWell },
                React.createElement("span", { className: "glyphicon glyphicon-info-sign", "aria-hidden": "true" }),
                React.createElement("h4", null, "Listing View data before Oct 1st 2016 is innacurate."),
                React.createElement("h5", null, "We are working on processing this data and will have it available in the near future."))));
    }
    render() {
        const { fromDate } = this.props;
        const fromMoment = moment(fromDate);
        const oct1 = moment("20161001", "YYYYMMDD");
        if (fromMoment >= oct1) {
            return React.createElement("div", null);
        }
        return (React.createElement("div", null,
            React.createElement(ShowByLoginType, { showOnLoginTypes: superUsers }, this.renderForInternalUsers()),
            React.createElement(ShowByLoginType, { showOnLoginTypes: nonSuperUsers }, this.renderForExternalUsers())));
    }
}
